import React from 'react';

interface ReportRecordCountProps {
  count: number;
}

const ReportRecordCount: React.FC<ReportRecordCountProps> = ({ count }) => {
  return (
    <div className="overflow-hidden mt-6">
      <div className="flex items-center">
        <div className="text-gray-600">
          {count} {count === 1 ? 'Record found' : 'Records found'}
        </div>
      </div>
    </div>
  );
};

export default ReportRecordCount;
